import { useEffect, useState } from "react";
import Logo from "../../images/Logo";
import DiscreetMessage from "../../parts/DiscreetMessage";
import { useParams } from "react-router-dom";
import Api from "../../Api";
import { Client, Quote } from "../../types";

type OrderData = {
  quote: Quote;
  client: Client;
  equipmentMap: Record<string, string>;
};
const TechnicalOrder = () => {
  const { uuid } = useParams();
  const [data, setData] = useState<OrderData | null>(null);
  const [note, setNote] = useState("");

  useEffect(() => {
    Api.technicalGetOrder(uuid!).then(setData);
  }, [uuid]);

  if (!data) return <DiscreetMessage text="Carregando ..." />;

  return (
    <div className="text-gray-900">
      <div className="border-b border-b-gray-900 bg-gray-50 print:hidden sticky top-0">
        <div className="p-2 flex items-center gap-4">
          <div className="text-sm flex-1 h-32 overflow-scroll tracking-tight leading-tight">
            <div className="font-bold my-1">Anotações do consultor</div>
            {!data.quote.note && (
              <div className=" py-2 text-gray-400 italic">Nenhuma</div>
            )}
            <div className="leading-tight text-gray-600 mb-4">
              {data.quote.note}
            </div>

            <div className="font-bold my-1">Anotações técnicas</div>
            {data.client.technicalNotes.length === 0 && (
              <div className=" py-2 text-gray-400 italic">Nenhuma</div>
            )}
            <ul className="leading-tight text-gray-600 list-disc pl-4 flex flex-col gap-1">
              {data.client.technicalNotes.map((note, i) => (
                <li key={i}>{note.text}</li>
              ))}
            </ul>
          </div>

          <div className="text-sm flex-1 h-32 flex flex-col">
            <div className="font-bold my-1">Observação na OS</div>
            <textarea
              className="w-full border rounded flex-1 py-1 px-2"
              value={note}
              onChange={(e) => setNote(e.target.value)}
              rows={3}
            ></textarea>
          </div>

          <button
            className="border rounded bg-white py-2 px-4 font-bold hover:bg-slate-50"
            onClick={() => window.print()}
          >
            Imprimir
          </button>
        </div>
      </div>

      <div className="w-[700px] mx-auto my-4 flex flex-col gap-4">
        <div className="flex flex-col items-center">
          <Logo h={37} />
        </div>

        <div className="text-lg font-bold text-center">Ordem de serviço</div>

        <div className="text-sm flex flex-col gap-0.5">
          <div>
            <div className="w-28 float-left font-bold text-right">Cliente</div>
            <div className="ml-28 px-2 tracking-tight">{data.client.name}</div>
          </div>

          <div>
            <div className="w-28 float-left font-bold text-right">Endereço</div>
            <div className="ml-28 px-2 tracking-tight">
              {data.client.street}, {data.client.number}, {data.client.area},{" "}
              {data.client.city}, {data.client.state} - {data.client.zipcode}
            </div>
          </div>

          <div>
            <div className="w-28 float-left font-bold text-right">CPF/CNPJ</div>
            <div className="ml-28 px-2">{data.client.document}</div>
          </div>
        </div>

        {(data.quote.itemsSold.length !== 0 ||
          data.quote.itemsRented.length > 0) && (
          <div className="flex flex-col gap-1">
            <div className="font-bold text-center">Equipamentos</div>
            <div className="px-16 text-sm">
              {data.quote.itemsSold
                .concat(data.quote.itemsRented)
                .map((item, i) => (
                  <div key={i} className="border-b pt-0.5 last:border-0">
                    <div className="w-8 float-left font-bold text-right">
                      {item.amount}x
                    </div>
                    <div className="ml-8 px-2">
                      {data.equipmentMap[item.equipmentUuid]}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        )}

        {note && (
          <div className="flex flex-col gap-1">
            <div className="font-bold text-center mb-1">Observações</div>
            <div className="text-sm tracking-tight leading-tight whitespace-pre-line px-8">
              {note}
            </div>
          </div>
        )}

        <div className="flex flex-col gap-1">
          <div className="font-bold text-center mb-1">Anotações</div>
          <div className="border rounded-xl h-48 mx-8"></div>
        </div>
      </div>
    </div>
  );
};

export default TechnicalOrder;
